import React from 'react';
import type {IntlShape} from 'react-intl';

import {useTexts} from '../hooks';

import styles from './styles.module.css';

type Props = {
    intl: IntlShape;
};

export const Hints = ({intl}: Props) => {
    const {hint1, hint2, hint3, hint4} = useTexts(intl);

    return (
        <ul className={styles.hints}>
            <li>{hint1}</li>
            <li>{hint2}</li>
            <li>{hint3}</li>
            <li>{hint4}</li>
        </ul>
    );
};
